export class tcontroldetParams {
  idEmpresa: number;
  idTcontrol: number;
  periodo: any;
  idUsuario: number;
  idSeccion: number;
  fileName: string;
}
